<!-- ATTEMPTS AT COMPOSITION API, a farce in one part, anon. -->

<script setup>
import { computed, defineProps } from "vue"
import { useStore } from "./../../utils"
import { /* discountTypes,  */ productTypes } from "../../store/constants"

import { getProductPromoAdjustment } from "../../store/cart"

import PriceRenderer from "./PriceRenderer.vue"

const props = defineProps({
  product: Object,
  quantity: { type: Number, default: 1 },
  adjustmentValue: Number,
  inverted: Boolean
})

const store = useStore()

///// MAPPED FROM STORE /////
const GET_HAS_GLOBAL_PRICE_ADJUSTMENT = computed(
  () => store.getters["content/GET_HAS_GLOBAL_PRICE_ADJUSTMENT"]
)
const GET_GLOBAL_DISCOUNT = computed(() => store.state.content.globalDiscount)

const GET_PROMO_DATA_BY_PRODUCT = computed(
  () => store.getters["content/GET_PROMO_DATA_BY_PRODUCT"]
)
/////////////////////////////

const GET_PROMO_DATA_THIS_PRODUCT = computed(() =>
  GET_PROMO_DATA_BY_PRODUCT.value(props.product.cmsId)
)

const getPrice = computed(() => {
  // If there is a global price adjustment, return the price after the adjustment
  // The globally-applied adjustment, if it exists, takes precedence over any other adjustment value
  if (GET_HAS_GLOBAL_PRICE_ADJUSTMENT.value) {
    const _adjVal =
      !(props.product && props.product.__typename == productTypes.GIFT_CARD) &&
      GET_GLOBAL_DISCOUNT.value.discountValue
    const _priceOutputGlobalAdj = _adjVal
      ? {
          ...props.product.price,
          cents: (props.product.price.cents * (100 - _adjVal)) / 100
        }
      : props.product.price
    return _priceOutputGlobalAdj
  }

  // If there is an adjustmentValue passed in, use that (eg, price adjustment from subscription option)
  if (props.adjustmentValue > 0) {
    const _priceOutputFromProps = {
      ...props.product.price,
      cents: (props.product.price.cents * (100 - props.adjustmentValue)) / 100
    }
    return _priceOutputFromProps
  }

  // If there is an active 'single item' discount promotion on the product (can either be matching PRODUCT or RANGE), reflect that by returning the price AFTER discount
  if (GET_PROMO_DATA_THIS_PRODUCT.value?.getIsTriggered == true) {
    //
    console.log(
      "GET_PROMO_DATA_THIS_PRODUCT",
      GET_PROMO_DATA_THIS_PRODUCT.value
    )
    const { adjustedUnitPriceCents } = getProductPromoAdjustment(
      props.product,
      GET_PROMO_DATA_THIS_PRODUCT.value
    )
    const _priceOutputFromPromo = {
      ...props.product.price,
      cents: adjustedUnitPriceCents
    }
    return _priceOutputFromPromo
  }

  // Otherwise return the price as declared. If there is a 'compare at price', then we still just use the current price as the price. Price price price
  return props.product.price
})

const getCompareAtPrice = computed(() => {
  // If there is a global price adjustment, or a passed-in adjustmentValue, return the price BEFORE the adjustment
  // If there is an active 'single item' discount promotion on the product, reflect that by returning the 'original' price BEFORE discount
  if (
    GET_HAS_GLOBAL_PRICE_ADJUSTMENT.value ||
    props.adjustmentValue > 0 ||
    GET_PROMO_DATA_THIS_PRODUCT.value?.getIsTriggered == true
  ) {
    return props.product.price
  }

  // If there is a 'compare at' price, then return that IF it's higher value than the actual price.
  if (
    props.product.compareAtPrice &&
    props.product.compareAtPrice.cents > props.product.price.cents
  ) {
    return props.product.compareAtPrice
  }

  return null
})
</script>

<template>
  <PriceRenderer
    :price="getPrice"
    :compareAtPrice="getCompareAtPrice"
    :quantity="props.quantity"
    :inverted="props.inverted"
  />
</template>

<style lang="scss">
.price-handler {
}
</style>
